import React from 'react';
import { Card, Empty } from 'antd';

import { useTranslation } from '../../i18n/useTranslation';
import { WIDGET_LOADING_STYLE } from './utils';
import { WidgetCardHeader } from './WidgetCardHeader';

interface Props {
    // Card heading shown in the WidgetCardHeader.
    title: string;
    // Whether the underlying query is in flight.
    loading: boolean;
    // Whether there is no data to render (drives the loading/empty/content branches).
    isEmpty: boolean;
    // The chart (or any content) rendered once data is available.
    children: React.ReactNode;
}

// Shared scaffold for the dashboard chart widgets: a bordered card with a header and the
// loading -> empty -> content rendering states, so each widget only supplies its chart.
export const ChartWidgetCard = ({ title, loading, isEmpty, children }: Props) => {
    const { t } = useTranslation();

    const renderContent = () => {
        if (loading && isEmpty) {
            return <div style={WIDGET_LOADING_STYLE}>{t('Loading')}</div>;
        }
        if (isEmpty) {
            return (
                <div style={WIDGET_LOADING_STYLE}>
                    <Empty description={t('NO_DATA_AVAILABLE')} />
                </div>
            );
        }
        return children;
    };

    return (
        <Card className="f-bordered f-dashboard-grid-card" title={<WidgetCardHeader title={title} loading={loading} />}>
            {renderContent()}
        </Card>
    );
};
